<template>
  <v-dialog
    :value="value" @input="$emit('input')"
    width="700"
  >

    <v-card>
      <v-card-title class="text-h5">
        <template v-if="item.mail_settings_id">Update Settings #{{ item.mail_settings_id }}</template>
        <template v-else>Create Settings</template>
      </v-card-title>

      <v-card-text>
        <select-project
          class="mb-2"
          :loading="loading"
          :disabled="loading"
          v-model="item.entity_id"
          required
          :return-object="false"
        ></select-project>

        <v-text-field
          class="mb-2"
          label="From"
          v-model="item.settings.from"
          hide-details
          :loading="loading"
          :disabled="loading"
          required
        />

        <v-text-field
          class="mb-2"
          label="Email"
          v-model="item.settings.email"
          :loading="loading"
          :disabled="loading"
          hide-details
          required
        />

        <v-text-field
          class="mb-2"
          label="User"
          v-model="item.settings.user"
          :loading="loading"
          :disabled="loading"
          hide-details
          required
        />

        <v-text-field
          class="mb-2"
          label="Password (secret)"
          v-model="item.settings.pass"
          :loading="loading"
          :disabled="loading"
          hide-details
          required
        />

        <v-text-field
          class="mb-2"
          label="SMTP"
          v-model="item.settings.smtp"
          :loading="loading"
          :disabled="loading"
          hide-details
          required
        />

        <v-text-field
          class="mb-2"
          label="Port"
          v-model.number="item.settings.port"
          :loading="loading"
          :disabled="loading"
          type="number"
          hide-details
          required
        />

        <fieldset class="px-2 pb-2 group-border">
          <legend class="px-2">Additional options</legend>
          <v-row class="ma-0 pa-0">
            <v-checkbox
              class="col-4 pt-0"
              label="System Notifications"
              v-model="item.settings.notifications"
              :loading="loading"
              :disabled="loading"
              hide-details
            />
          </v-row>
        </fieldset>

      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn
          color="warning"
          text
          :loading="loading"
          :disabled="loading"
          @click.native="$emit('input')"
        >
          Close
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="info"
          text
          :loading="loading"
          :disabled="loading"
          @click="saveAs(item)"
        >
          Save as
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          :loading="loading"
          :disabled="loading"
          @click="save(item)"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
  import { removeDuplicateValues } from '@/utils/helper'
  import { API } from '@/utils/api'
  import { omit } from 'lodash'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'

  export default {
    props: {
      value: { default: false },
      refresh: { default: false },
      item: { required: true, type: Object },
      initItem: { required: true, type: Object },
    },

    components: { SelectProject },

    data: () => ({
      loading: false,
      template: null,
      templates: [],
    }),

    watch: {},

    methods: {
      keys (obj) {
        if (!obj) return {}
        return Object.keys(obj)
      },

      async save (item, message = 'Save mail setting', saveAndClose = true) {
        let buttons = []
        const uniqItem = removeDuplicateValues(item, this.initItem)
        if (!saveAndClose) {
          buttons = [
            { text: 'Save', value: 'close', class: 'primary darken-1' },
            { text: 'Cancel', value: false, class: 'grey' },
          ]
        } else {
          buttons = [
            { text: 'Save', value: true, class: 'primary darken-1' },
            { text: 'Save and close', value: 'close', class: 'primary darken-1' },
            { text: 'Cancel', value: false, class: 'grey' },
          ]
        }
        if (!Object.keys(uniqItem).length) {
          await this.$root.$confirm('No changes found', 'Please, update the mail settings', { width: 515, buttons: [ { text: 'Ok', value: false, class: 'primary darken-1' } ] })
          return
        }

        let confirmRes = await this.$root.$confirm('Confirm', message, { width: 515, buttons })

        if (!confirmRes) {
          return
        }

        this.loading = true
        return API.call('/mail/settings/update.json', { entity_id: this.item.entity_id, mail_settings_id: this.item.mail_settings_id, ...uniqItem }).then(resp => {

          this.$notification.show = true
          this.$notification.message = 'Mail settings updated'
          this.$notification.type = 'success'

          return this.refresh()
        }).finally(() => {
          this.loading = false

          if (confirmRes == 'close') {
            this.$emit('input')
          }
        })
      },
      async saveAs (item) {
        return this.save(omit(removeDuplicateValues(this.initItem, item), 'mail_settings_id'), 'Save mail settings as new', false)
      }
    }
  }
</script>
